/* eslint-disable */
// import { useState } from "react";

interface Props {
  isEnabled: boolean;
  toggleState?: any;
  fieldName?: any;
  setFieldValue?: any;
  fieldObj?: any;
}

function CovidDetailsTogglebutton({
  isEnabled,
  toggleState,
  setFieldValue,
  fieldName,
  fieldObj = ""
}: Props) {
  // Initialize a state variable to track the switch's state (ON or OFF)
  // const [isOn, setIsOn] = useState(true);

  // Function to handle the toggle when the switch is clicked
  const toggleSwitch = () => {
    // if (isEnabled) {
    //   setIsOn((prevIsOn) => !prevIsOn); // Toggle the state only if not on the review page
    if (fieldObj.length > 1) {
      setFieldValue(`${fieldObj}.${fieldName}`, !toggleState);
    } else {
      setFieldValue(fieldName, !toggleState);
    }
    // }
  };

  return (
    <label
      className={`flex items-center relative cursor-pointer select-none rounded-2xl xl:w-12.5 xl:h-6.25 lg:w-12.5 lg:h-6.25 md:w-12.5 md:h-6.25 sm:w-12.5 sm:h-6.25 w-10 h-5 ${
        toggleState ? "bg-outrageousGreen" : "bg-hotShot"
      }`}
      onChange={toggleSwitch} // Call the toggle function when the label is clicked
    >
      <input
        type="checkbox"
        className={`${
          !isEnabled
            ? " appearance-none transition-colors cursor-pointer  xl:w-12.5 xl:h-6.5 lg:w-12.5 lg:h-6.5 md:w-12.5 md:h-6.5 sm:w-12.5 sm:h-6.5 w-10 h-5  rounded-2xl bg-mercury"
            : "appearance-none transition-colors cursor-pointer xl:w-12.5 xl:h-6.5 lg:w-12.5 lg:h-6.5 md:w-12.5 md:h-6.5 sm:w-12.5 sm:h-6.5 w-10 h-5 rounded-2xl bg-white-200 " // Conditionally apply the disabled button class
        }`}
        // className={`appearance-none transition-colors cursor-pointer w-10 h-7 rounded-full rounded-2xl bg-white-200 ${
        //   isEnabled ? "pointer-events-none" : ""
        // }`}
        checked={toggleState}
        {...(!isEnabled ? { disabled: true } : {})} // Conditionally omit the disabled attribute
      />
      {!toggleState &&
        (!isEnabled ? (
          <span className="font-montserrat absolute text-3 xl:right-2 lg:right-2 md:right-2 sm:right-2 right-1 text-daintree">
            No
          </span>
        ) : (
          <span className="font-montserrat text-xs font-semibold absolute text-3 xl:right-2 lg:right-2 md:right-2 sm:right-2 right-1 text-white">
            No
          </span>
        ))}
      {toggleState &&
        (isEnabled ? (
          <span className="font-montserrat text-xs font-semibold absolute text-3 xl:right-[1.4rem] lg:right-5 md:right-5 sm:right-5 right-4 text-white">
            Yes
          </span>
        ) : (
          <span className="font-montserrat absolute text-3 xl:right-5 lg:right-5 md:right-5 sm:right-5 right-4 ">
            No
          </span>
        ))}

      <span
        className={` xl:w-4.75 xl:h-4.75 lg:w-4.75 lg:h-4.75 md:w-4.75 md:h-4.75 sm:w-4.75 sm:h-4.75 w-3.5 h-3.5 absolute rounded-full transform transition-transform ${
          toggleState
            ? "bg-white border-1 border-white right-0"
            : !isEnabled
            ? "bg-white xl:right-7.5 lg:right-7.5 md:right-7.5 sm:right-7.5 right-6 border-2 border-mercury"
            : "bg-white xl:right-7.5 lg:right-7.5 md:right-7.5 sm:right-7.5 right-6 border-2 border-hotShot"
        }`}
      />
    </label>
  );
}

export default CovidDetailsTogglebutton;
